import { toSelect } from '../../constants';
import { DocumentType } from './types';

export const PERU_BANK_ACCOUNT_TYPES = {
  savings: { value: 'savings', label: 'peruBankAccount.savings' }
};

export const documentTypes = [
  { value: DocumentType.DNI, label: 'DNI' },
  { value: DocumentType.C_EXTRANJERIA, label: 'CE' },
  { value: DocumentType.PASSPORT, label: 'passport' }
];

export const peruOptions = (bankEntities: Array<Record<string, string>>) => {
  return {
    documentType: {
      name: 'documentType',
      label: 'document type',
      select: true,
      options: documentTypes,
      md: 3
    },
    personalIdTypeInputOptions: {
      name: 'personalId',
      label: 'document number',
      md: 3
    },
    colombiaBankAccountTypeInputOptions: {
      name: 'bankAccountType',
      label: 'bank account type',
      select: true,
      options: Object.values(PERU_BANK_ACCOUNT_TYPES),
      md: 6
    },
    bicSwiftInputOptions: {
      name: 'bic_swift',
      label: 'bic swift',
      select: true,
      options: Object.values(toSelect(bankEntities, 'Banco')),
      md: 6
    },
    addressInputOptions: {
      name: 'address',
      label: 'address',
      md: 12
    },
    exclude: 'iban'
  };
};
